export enum RSSClockFormat {
  TwelveHour,
  TwentyFourHour
}
